import { Observable } from 'rxjs';

import {
	DeviceUserPerspective,
	LocalizationSensitivity,
	ReflectionCorrection,
	VoiceActivityDetectionSensitivity
} from '@shure/shared/angular/data-access/system-api/core';
import {
	CoverageMode,
	DeviceRotation,
	MeasurementUnit,
	Placement,
	RotationAxis
} from '@shure/shared/angular/data-access/system-api/models';
import { PositionPoint, PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { CoverageDevice, CoverageTalkerPosition } from './models';

export abstract class CoverageDeviceApiService {
	public abstract getDevice$(deviceId: string): Observable<CoverageDevice>;
	public abstract setDevicePosition(deviceId: string, position: PositionPoint): Observable<void>;
	public abstract setDeviceRoomRotation(deviceId: string, rotation: number, axis?: RotationAxis): Observable<void>;
	public abstract setDeviceLocalRotation(deviceId: string, rotation: DeviceRotation): Observable<void>;
	public abstract setDeviceHeight(deviceId: string, listenerHeight: PositionUnit): Observable<void>;
	public abstract setDeviceListenerHeight(deviceId: string, height: PositionUnit): Observable<void>;
	public abstract setCoverageMode(deviceId: string, coverageMode: CoverageMode): Observable<void>;
	public abstract setDeviceInstallation(deviceId: string, placement: Placement): Observable<void>;
	public abstract flipDevice(deviceId: string, newAngle: number): Observable<void>;
	public abstract setDeviceAudioAutoFocus(deviceId: string, enabled: boolean): Observable<void>;
	public abstract setMetricsIncluded(deviceId: string, metricsIncluded: boolean): Observable<void>;
	public abstract setLocalizationSensitivity(
		deviceId: string,
		localizationSensitivity: LocalizationSensitivity
	): Observable<void>;
	public abstract setPositionUpdateRate(deviceId: string, positionUpdateRate: number): Observable<void>;
	public abstract setReflectionCorrection(
		deviceId: string,
		reflectionCorrection: ReflectionCorrection
	): Observable<void>;
	public abstract setVoiceActivityDetectionSensitivity(
		deviceId: string,
		voiceActivityDetectionSensitivity: VoiceActivityDetectionSensitivity
	): Observable<void>;
	public abstract subscribeTalkerTracking$(deviceId: string): Observable<CoverageTalkerPosition[]>;
	public abstract setCoverageLock(deviceId: string, enabled: boolean): Observable<void>;
	public abstract setUserPerspective(deviceId: string, userPerspective: DeviceUserPerspective): Observable<void>;
	public abstract updateMeasurementUnit(deviceId: string, measurementUnit: MeasurementUnit): Observable<void>;
}
